import ClientContext from "../../../common/utils/client-context/ClientContext";
import { isEmailValid, isNameValid, isMobileValid } from "../../utils/user-validation/UserValidation";
import { areAnyFieldsPristine } from "../../../expert/utils/FieldValidators";
export var validateCustomer = function validateCustomer(customer, translate, skipQuestion) {
  var isFormInvalid = true;
  var fieldErrors = {};
  var name = customer.name,
      email = customer.email,
      question = customer.question,
      mobileNumber = customer.mobileNumber;
  var fieldsToValidate = {
    name: name,
    email: email
  };

  if (!skipQuestion) {
    fieldsToValidate.question = question;
  }

  var isFormIncomplete = false;

  if (ClientContext._userMobileEnabled === "true") {
    fieldsToValidate.mobileNumber = mobileNumber;
    isFormIncomplete = areAnyFieldsPristine(fieldsToValidate);

    if (!mobileNumber.pristine && !isMobileValid(mobileNumber.value)) {
      fieldErrors.mobileNumber = "Please enter a valid mobile number";
    }
  } else {
    isFormIncomplete = areAnyFieldsPristine(fieldsToValidate);
  }

  if (!name.pristine && !isNameValid(name.value)) {
    fieldErrors.name = "Name must be at least 2 characters";
  } else if (!name.pristine && name.value.includes("@")) {
    fieldErrors.name = "Name must not contain an email address";
  }

  if (!email.pristine && !isEmailValid(email.value)) {
    fieldErrors.email = "Please enter a valid email";
  }

  if (!skipQuestion && !question.pristine) {
    var trimmedQuestion = question.value;

    if (question.value.trim() === "") {
      trimmedQuestion = question.value.trim();
    }

    if (trimmedQuestion.length < ClientContext._minQuestionCharCount) {
      fieldErrors.question = translate("Your question should be at least {0} characters", ClientContext._minQuestionCharCount);
    }

    if (trimmedQuestion.length > 4000) {
      fieldErrors.question = "Your question must be less than 4,000 characters";
    }
  }

  isFormInvalid = isFormIncomplete || Object.keys(fieldErrors).length > 0;
  return {
    isFormInvalid: isFormInvalid,
    fieldErrors: fieldErrors
  };
};